import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @file Created on Wed Aug 08 2018
 * @author BPo
 */
import initialize from '@logio/common-be-fe';
import { updateConstants } from './constants';

var Configuration =
/*#__PURE__*/
function () {
  function Configuration() {
    _classCallCheck(this, Configuration);

    initialize();
  }
  /**
   * Will initialize the common-fe app. This should be called in derived app as soon as possible!
   *
   * @param {Constants=} constants You can optionally pass new constants to update default configuration.
   * This allows you to mutate original constants object.
   */


  _createClass(Configuration, [{
    key: "init",
    value: function init(constants) {
      updateConstants(constants);
    }
  }]);

  return Configuration;
}();
/** Configuration is exported as singleton instance. */


export default new Configuration();